import type { InjectionKey } from 'vue'

export const reloadReviewsProductKey = Symbol('reloadReviewsProduct') as InjectionKey<() => void>
export const reloadReviewsAgencyKey = Symbol('reloadReviewsAgency') as InjectionKey<() => void>
